const API_PATH = {
  AdminLogin: "/auth/login",
  WelcomeScreen: "/customer",
  DeleteByEmailId: "/deleteByEmailid/",
  AddProductCategory: "/product/category",
  ProductStatus: "/product/status",
  Pagenumber: "/customerAddress/getpageNumber",
  AddEmployee: "/employee",
  Addtag: "/mastertag/addtag",
  createnotification: "/notification/sendnotification",
  getNotificationById: "/notification/getByIdNotification/",
  EmployeeStatus: "/employee/status",
  EmployeeRole: "/employee/roles",
  AddMedia: "/media",
  Editbanner: "/media/updatebanner",
  AddBanner: "/media/createBanner",
  Getbanner: "/media/getBanner",
  EditStore: "/store/storeupdate",
  AddStore: "/store/storeadd",
  AddBrand: "/brand/createBrand",
  AddWidget: "/wedgetTitle/addWidget",
  AddModule: "/userManagement/module/createModule",
  GetProductCategoryWithoutPage: "/product/category/withoutPagination",
  GetProductSubCategoryWithoutPage: "/product/subcategory/withoutPagination",
  AddProduct: "/product",
  GetPincodeproduct: "/product/getallpincodeProducts",
  AddProfile: "/userManagement/profile/createProfile",
  GetAllModules: "/userManagement/module/getAll/withoutPagination",
  GetModuleMode: "/userManagement/module/moduleModes",
  AddRole: "/userManagement/role",
  GetRoleTree: "/userManagement/role/tree",
  GetAllRole: "/userManagement/role/all",
  GetAllProfile: "/userManagement/profile/all",
  AddSlider: "/slider",
  GetAllMedia: "/media/getAllMedia",
  GetCategoryImage: "/product/category/getCategoryImage/",
  GetSubCategoryImage: "/product/category/getSubcategoryImage/",
  AddSubCategory: "/product/subcategory",
  GetSubCategories: "/product/subcategories",
  GetCategory: "/product/category",
  DeleteCategory: "/product/category/deleteByID/",
  GetCustomer: "/customer",
  DeleteCustomer: "/customer/deleteByPhonenumber/",
  GetCategoryById: "/product/category/getById/",
  EditCategory: "/product/category",
  GetCustomerByPhone: "/customer/getByPhonenumber/",
  GetCustomerCity: "/customer/cities",
  GetCustomerState: "/customer/states",
  GetCustomerCountry: "/customer/countries",
  GetCustomerStatus: "/customer/getStatus",
  GetCustomerRole: "/customer/getRoles",
  GetEmployeByEmail: "/employee/getByEmailid/",
  GetmediaById: "/media/getById/",
  GetBannerById: "/media/getBannerById/",
  GetstoreById: "/store/getById/",
  GetModuleById: "/userManagement/module/getById/",
  EditModule: "/userManagement/module/updateModule",
  GetProductById: "/product/getById/",
  GetProfileById: "/userManagement/profile/getByID/",
  EditProfile: "/userManagement/profile/updateProfile",
  GetRoleById: "/userManagement/role/getByID/",
  GetValidParentsRole: "/userManagement/role/validParents/",
  GetSliderById: "/slider/getById/",
  GetProductSubCategoryById: "/product/subcategory/getById/", // by subcategoryid
  GetProductSubCategoryDataById: "/product/subcategory/item/GetByID/", // by _id
  DeleteSubCategory: "/product/subcategory/deleteByID/",
  DeleteEmployee: "/employee/deleteByEmailid/",
  GetFeedback: "/feedback",
  GetStore: "/store/storeadmin",
  GetFeedbackById: "/feedback/getByID/",
  ForgetPassword: "/auth/forgotPassword",
  DeleteMedia: "/media/deleteById/",
  DeleteBanner: "/media/deletebannerById/",
  DeleteTag: "/mastertag/deleteById/",
  getByIdTag: "/mastertag/getById/",
  getByIdNotification: "/notification/getByIdNotification/",
  DeleteNotification: "/notification/deleteById/",
  Deletewidget: "/wedgetTitle/deletewidget/",
  GetModulePage: "/userManagement/module/getModule",
  DeleteModule: "/userManagement/module/deleteModule/",
  GetOrder: "/order",
  GetOrderById: "/order/getByID/",
  DeleteProduct: "/product/deleteById/",
  GetProfilePage: "/userManagement/profile/getProfiles",
  DeleteProfile: "/userManagement/profile/",
  RolePage: "/userManagement/role/page",
  DeleteSlider: "/slider/deleteById/",
  DeleteStore: "/store/deleteById/",
  DeleteBrand: "/brand/deleteBrand/",
  category: "/product/category",
  subcaterogy: "/product/subcategory",
  wedgettitle: "/wedgetTitle/getAllnewwidgets",
  GetwedgetById: "/wedgetTitle/getWidgetWithProducts/",
  GetWidgetId: "/wedgetTitle/getWidgetById/",
  GetBrandById: "/brand/getBrandById/",
  UpdateWedget: "/wedgetTitle/updatenewwidget/",
  updateProductsInWidget: "/wedgetTitle/updateProductsInWidget",
  UpdateWedgetProduct: "/wedgetTitle/addProductsToWidget",
  Updatbrand: "/brand/updateBrand/",
  UpdatTag: "/mastertag/tags",
  EditNotification: "/notification/updateUpdateNotification",
  getBrand: "/brand/getAllBrands",
  getallbrandnamewithoutpagination: "/brand/getallbrandnamewithoutpagination",
  getalltagwithoutpagination: "/mastertag/getalltagwithoutpagination",
  GetexoticProducts: "/product/exoticProducts",
  LastMinuteAddons: "/product/lastMinuteAddons",
  Bestsellers: "/product/bestsellers",
  GetIShotDeals: "/product/hotdeals",
  GetIsTrendingInYourArea: "/product/trendinginyourarea",
  GetIsTrendingOffers: "/product/trendingoffers",
  GetIsHealthySnacking: "/product/healthysnacking",
  Getblinkit: "/store/getblinkit",
  getStoreClicks: "/product/getStoreClicks",
  getBestdealsClicks: "/product/getbestdealclick",
  getallpincode: "/product/getPincode",
  Getbigbasket: "/store/getbigbasket",
  getAllTags: "/mastertag/getAllTags",
  getAllnotification: "/notification/getallnotification",
};

export default API_PATH;